export default {
  NONE: "none",
  ADVISOR: "advisor",
  ADVISOR_AND_ACCOUNT_MANAGER: "advisor_and_account_manager",
  ACCOUNT_MANAGER: "account_manager",
  USER_DEPARTMENTS: "user_departments",
};
